<app-table-column name="date" size="small" (click)="itemClicked('date')">
  <span content>{{formatDate(crate.receivedAt)}}</span>
</app-table-column>

<app-table-column name="date" size="small" (click)="itemClicked('date')">
  <span content>{{formatDate(crate.lastMovedAt)}}</span>
</app-table-column>

<app-table-column name="sector" size="small" (click)="itemClicked('sector')">
   <span content>{{crate.section || '---'}}</span>
</app-table-column>

<app-table-column name="address" size="small" (click)="itemClicked('address')">
  <span content>  {{ toExcelFormat(crate.x, crate.y) }}  </span>
</app-table-column>

<app-table-column name="alias" size="smaller" (click)="itemClicked('alias')">
  <span content> {{ crate.alias || '---' }} </span>
</app-table-column>

<app-table-column name="height" size="smaller" (click)="itemClicked('height')">
  <span content>{{ crate.z >= 0 ? centimetersToMeters(crate.z) + ' metros' : 'Conflitante' }}</span>
</app-table-column>

<app-table-column name="product-code" size="small" (click)="itemClicked('product-code')">
  <span content>
    <span *ngFor="let product of crate.skuGroups">{{ product.sku }}</span>
  </span>
</app-table-column>

<app-table-column name="description" size="medium" (click)="itemClicked('description')">
  <span content>
    <span *ngFor="let product of crate.skuGroups">{{ product.name }}</span>
  </span>
</app-table-column>

<!-- <app-table-column name="family" size="medium" (click)="itemClicked('family')">
  <span content>
    <span *ngFor="let product of crate.skuGroups">{{ product.description }}</span>
  </span>
</app-table-column> -->

<app-table-column name="quantity" size="smallest" (click)="itemClicked('quantity')">
  <span content>
    <span *ngFor="let product of crate.skuGroups">
      {{ product.quantity * product.packSize | number : '1.0-0' : 'pt-BR' }}
    </span>
  </span>
</app-table-column>

<app-table-column name="state" size="small" (click)="itemClicked('state')">
  <span content>{{ translateState(crate.state) }}</span>
</app-table-column>

<app-table-column name="messages" size="smallest" (click)="itemClicked('messages')">
  <span content>
    <i *ngIf="!crate.commentsQty" class="uil uil-comment"></i>
    <i *ngIf="crate.commentsQty" class="uil uil-comment-lines"></i>
    {{ crate.commentsQty }}
  </span>
</app-table-column>